const { createApp, ref, component, watch, onMounted, reactive, onBeforeMount, onUnmounted, onUpdated } = Vue;

const compatibleAddonsApp = createApp({
	name: "compatibleAddonsApp",
	setup(props) {
		const compatibleAddonData = ref(compatibleAddonDataObj);
		const AtcPayload = ref({
			main_product: null,
			addon: null,
		});
		const isSubmitting = ref(false);
		const mainProductVariant = ref(null);
		const compatibleProductObj = ref(null);
		const totalPrice = ref({
			discount_price: null,
			sale_price: 0,
		});
		const canSubmit = ref(true);

		onBeforeMount(() => {
			const selectedVariantEl = document.querySelector(".product-info__buy-buttons input[name='id']");
			const selectedVariant = compatibleAddonData.value.main_product.variants.find(
				(v) => v.id == selectedVariantEl.value
			);
			mainProductVariant.value = selectedVariant;
			AtcPayload.value.main_product = mainProductVariant.value;
			setCompatibleProductForCurrentVariant();
		});

		onMounted(() => {
			document.getElementById('compatibleAddonsApp').style.visibility = "visible";
			document.addEventListener("variant:change", handleMainProductVariantSelect);
			document.addEventListener("plan:changed",handleMainProductPurchasePlanChange);
			// Time out added to prevent race condition since there is a delay in window.mainProduct price update from price logic script.
			setTimeout(() => calculateTotalPrice(), 1200);
		});

		watch(AtcPayload.value, () => {
			// Time out added to prevent race condition since there is a delay in window.mainProduct price update from price logic script.
			setTimeout(() => calculateTotalPrice(), 500);
			if (
				(AtcPayload.value.main_product && !AtcPayload.value.main_product.available) ||
				(AtcPayload.value.addon && !AtcPayload.value.addon.available)
			) {
				canSubmit.value = false;
			} else {
				canSubmit.value = true;
			}			
		});

		function handleMainProductPurchasePlanChange(){
			// Time out added to prevent race condition since there is a delay in window.mainProduct price update from price logic script.
			setTimeout(() => calculateTotalPrice(), 1200);
		}

		function handleMainProductVariantSelect(e) {
			// console.log("variant change");
			if (e?.detail?.variant) {
				const selectedVariant = compatibleAddonData.value.main_product.variants.find(
					(v) => v.id == e.detail.variant.id
				);
				mainProductVariant.value = selectedVariant;
				AtcPayload.value.main_product = mainProductVariant.value;
				setCompatibleProductForCurrentVariant();
			}
		}

		function setCompatibleProductForCurrentVariant() {
			compatibleProductObj.value = compatibleAddonData.value.mappings.find((m) =>
				m.variant_types.includes(mainProductVariant.value.title)
			);
			if (compatibleProductObj.value && compatibleProductObj.value.block_type === "compatibility_discontinued") {
				AtcPayload.value.addon = null;
			}
		}

		function handleAddonVariantSelect(e) {
			AtcPayload.value.addon = e;
		}

		function calculateTotalPrice() {
			let totalSalePrice = 0;
			let totalDiscountPrice = 0;

			for (const key in AtcPayload.value) {
				if(AtcPayload.value[key]){
					if(key === 'main_product' && window.mainProductPrice){
						totalSalePrice += window.mainProductPrice.sale_price;
						if(AtcPayload.value.addon != null && AtcPayload.value.addon?.compare_at_price != null){
							totalDiscountPrice += window.mainProductPrice.discount_price || window.mainProductPrice.sale_price;
						}else{
							totalDiscountPrice += window.mainProductPrice.discount_price || 0;
						}						
					}

					if(key === 'addon'){
						totalSalePrice += AtcPayload.value.addon.compare_at_price || AtcPayload.value.addon.price;
						if(totalDiscountPrice != 0 || AtcPayload.value.addon.compare_at_price){
							totalDiscountPrice +=AtcPayload.value.addon.price;
						}
					}
				}
			}

			totalPrice.value = { sale_price: totalSalePrice, discount_price: totalDiscountPrice };
		}

		function handleMainProductToggle(e){			
			if(!e.target.checked){
				AtcPayload.value.main_product = null;
				return;
			}
			AtcPayload.value.main_product = mainProductVariant.value;
		}

		async function handleAddToCart() {
			try {
				const cartPayload = { items: [] };
				const sellingPlanElement = document.querySelector('form.shopify-product-form input[name="selling_plan"]');
				const sellingPlanId = sellingPlanElement ? sellingPlanElement.value : null;
				
				if (AtcPayload.value.main_product) {
					const item = {
						id: AtcPayload.value.main_product.id,
						quantity: 1,
					};

					if (sellingPlanId) {
						item.selling_plan = sellingPlanId;
					}				
					cartPayload.items.push(item);
				}

				if (AtcPayload.value.addon) {
					cartPayload.items.push({
						id: AtcPayload.value.addon.id,
						quantity: 1,
						properties: {
							_compare_at_price: AtcPayload.value.addon.compare_at_price || 0,
							_compare_at_price_discount: calculateDiscountPercentage(
								AtcPayload.value.addon.compare_at_price,
								AtcPayload.value.addon.price
							),
						},
					});
				}
				isSubmitting.value = true;
				await fetch(window.Shopify.routes.root + "cart/add.js", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify(cartPayload),
				});
			} catch (error) {
				console.error(error);
			} finally {
				isSubmitting.value = false;
			}
		}

		function renderSectionTitle(){
			let sectionTitle = compatibleAddonData.value.section_title;
			let productTitle = '';

			if(compatibleProductObj.value.block_type === 'compatibility_mapping'){
				productTitle = compatibleProductObj.value.pairs_with.title;
			}

			if(compatibleProductObj.value.block_type === 'compatibility_discontinued'){
				productTitle = compatibleProductObj.value.product_name;
			}

			return sectionTitle.replace("${product_title}", `<span>${productTitle}</span>`);
		}

		return {
			compatibleAddonData,
			AtcPayload,
			isSubmitting,
			mainProductVariant,
			compatibleProductObj,
			totalPrice,
			canSubmit,
			imgUrl,
			handleAddToCart,
			handleMainProductToggle,
			handleAddonVariantSelect,
			formatMoney, // Global function
			renderSectionTitle
		};
	},
	delimiters: ["${", "}"],
});

compatibleAddonsApp.component("compatibility-mapping", {
	template: "#compatibilityMappingComponent",
	emits: ["on-variant-select"],
	props: ["block_data"],
	setup(props, ctx) {
		const selectedVariant = ref(null);
		const isDropdownOpen = ref(false);
		const isEnabled = ref(true);

		onBeforeMount(() => {
			selectedVariant.value = props.block_data.pairs_with.variants.find((v) => v.available);
		});

		watch(
			() => props.block_data,
			() => {
				selectedVariant.value = props.block_data.pairs_with.variants.find((v) => v.available);
				isEnabled.value = true;
			}
		);

		watch(selectedVariant, () => {
			ctx.emit("on-variant-select", selectedVariant.value);
		});

		function handleVariantSelect(variantId) {
			selectedVariant.value = props.block_data.pairs_with.variants.find((v) => v.id === variantId);
			isDropdownOpen.value = false;
		}

		function extractColor(inputString) {
			if (inputString.includes("/")) {
				return inputString.split("/")[1].trim();
			}
			return inputString.trim();
		}

		function handleDropdownToggle() {
			isDropdownOpen.value = !isDropdownOpen.value;
		}

		function handleAddonToggle(e){
			isEnabled.value = e.target.checked;
			if(!isEnabled.value){
				ctx.emit("on-variant-select", null);
				return;
			}
			ctx.emit("on-variant-select", selectedVariant.value);
		}

		function handleCheckboxChecked(){
			return isEnabled;
		}

		return {
			selectedVariant,
			isDropdownOpen,
			isEnabled,
			imgUrl,
			extractColor,
			handleVariantSelect,
			getColorSwatch,
			handleDropdownToggle,
			handleAddonToggle,
			handleCheckboxChecked
		};
	},
	delimiters: ["${", "}"],
});

compatibleAddonsApp.component("compatibility-discontinued", {
	template: "#discontinuedComponent",
	props: ["block_data"],
	setup(props, ctx) {
		return {
			imgUrl,
		};
	},
	delimiters: ["${", "}"],
});

compatibleAddonsApp.mount("#compatibleAddonsApp");

function imgUrl(url, size) {
	// remove any current image size then add the new image size
	return url
		.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, ".")
		.replace(/\.jpg|\.png|\.gif|\.jpeg/g, function (match) {
			return "_" + size + match;
		});
}

function calculateDiscountPercentage(originalPrice, discountedPrice) {
    if (!originalPrice || originalPrice <= 0) {
        return 0;
    }
    const discountPercentage = ((originalPrice - discountedPrice) / originalPrice) * 100;
    return discountPercentage.toFixed();
}

function getColorSwatch(variantTitle) {
	let variantName = variantTitle.split("/");
	const colorMapping = {
		"midnight black": "#00040d",
		'midnight black': '#00040d',
		'miami heat black': '#00040d',
		'black': '#00040d',
		'negro': '#00040d',
		'miami heat negro': '#00040d',
		'negro medianoche': '#00040d',
		'medianoche': '#00040d',
		'medianoche negro': '#00040d',
		'aroma x hc collab wireless pro - black': '#00040d',
		'aroma x hc collab wireless pro - negro': '#00040d',
		'silver': '#BCC6CC',
		'metallic silver': '#BCC6CC',
		'metallic': '#BCC6CC',
		'plata metálico': '#BCC6CC',
		'metálico': '#BCC6CC',
		'plata': '#BCC6CC',
		'mickey mouse silver': '#BCC6CC',
		'mickey mouse metálico': '#BCC6CC',
		'medianoche metálico': '#BCC6CC',
		'blue': '#465999',
		'azul': '#465999',
		'green': '#758270',
		'verde': '#758270',
		'red': '#932A30',
		'rojo': '#932A30',
		'purple': '#800080',
		'morado': '#800080',
		'pink': '#EDC6BF',
		'fly': '#EDC6BF',
		'rosado': '#EDC6BF',
		'aroma x hc collab wireless pro - champagne': '#e5d2bd',
		'aroma x hc collab wireless pro - champan': '#e5d2bd',
		'champagne': '#e5d2bd',
		'aroma x hc collab wireless pro - space grey': '#717378',
		'aroma x hc collab wireless pro - espacio gris': '#717378',
		'space gray': '#717378',
		'donald duck': '#3b80df',
		'princess':'#E73F85',
		'mickey mouse':'#00040d',
		'darth vader': '#000000',
		'storm trooper': '#d3d3d3',
		'c-3po':'#ebbb52',
		'light side': '#fafafa',
		'dark side': '#000',
		'r2-d2':'#002eff'
		// Add more colors as needed
	};
	let lowercaseName = variantName[variantName.length - 1];
	lowercaseName = lowercaseName.toLowerCase();
	////console.log(lowercaseName,"lowercase name");
	let colorCode = "#ffffff";
	for (const key in colorMapping) {
		if (lowercaseName.includes(key)) {
			colorCode = colorMapping[key];
			break;
		}
	}
	return colorCode;
}
